import { combineEpics } from 'redux-observable';
import type { Action } from '../state/actions';
import type { AppState } from '../state/types';
import analyticsEpic from './analytics';
import analyticsAvatarUploadedEpic from './analytics-avatar-uploaded';
import analyticsProjectUpdatedEpic from './analytics-project-updated';
import deleteProjectEpic from './delete-project';
import fetchInstancePropertiesEpic from './fetch-instance-properties';
import fetchProjectCategories from './fetch-project-categories';
import fetchProjectDetailsEpic from './fetch-project-details';
import redirectAfterArchiveEpic from './redirect-after-archive';
import redirectAfterDeleteEpic from './redirect-after-delete';
import redirectAfterTrashEpic from './redirect-after-trash';
import reloadAOnRefreshEpic from './reload-on-refresh';
import saveAllProjectDetailsEpic from './save-all-project-details';
import saveButtonClickedEpic from './save-button-clicked';
import saveProjectDetailsEpic from './save-project-details';
import uploadAvatarEpic from './upload-avatar';

export default combineEpics<Action, AppState>(
	deleteProjectEpic,
	fetchProjectDetailsEpic,
	redirectAfterDeleteEpic,
	redirectAfterTrashEpic,
	// @ts-expect-error - TS2345: Type 'Observable<number>' is not assignable to type 'Observable<Action>'. Type 'number' is not assignable to type 'Action'.
	reloadAOnRefreshEpic,
	saveProjectDetailsEpic,
	redirectAfterArchiveEpic,
	saveAllProjectDetailsEpic,
	uploadAvatarEpic,
	analyticsEpic,
	analyticsProjectUpdatedEpic,
	fetchProjectCategories,
	saveButtonClickedEpic,
	fetchInstancePropertiesEpic,
	analyticsAvatarUploadedEpic,
);
